// import { connect } from "react-redux";
import { connect } from "react-redux";
// 筛选项管理
import ScreeningItem from "../components/ScreeningItem";

const mapState = state => ({
  // 筛选项数据
  screeningItem: state.orderInfo.screeningItem
});

const mapDispatch = dispatch => {
  return {
    // 获取筛选项列表
    getItemsList: dispatch.orderInfo.getItemsList
  };
};

export default connect(
  mapState,
  mapDispatch
)(ScreeningItem);
